import { useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { EnvService, IStorageSession } from 'namirasoft-core';
import { NSNotFoundPage } from 'namirasoft-site-react';
import { NSARouterMakerProps, NSARouterMaker } from 'namirasoft-account-react';
import { NamirasoftNotificationSenderServer } from 'namirasoft-notification-sender';
import { NamirasoftEmailSenderServer } from 'namirasoft-email-sender';
import { NotificationSenderRoutes } from './NotificationSenderRoutes';
import { NamirasoftSMSSenderServer } from 'namirasoft-sms-sender';
import { NamirasoftTelegramSenderServer } from "namirasoft-telegram-sender";
import { ProductUUID } from 'namirasoft-api-product';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import TopicListPage from './pages/TopicListPage';
import TopicEditPage from './pages/TopicEditPage';
import SubscriberListPage from './pages/SubscriberListPage';
import TopicViewPage from './pages/TopicViewPage';
import SubscriberEditPage from './pages/SubscriberEditPage';
import SubscriberViewPage from './pages/SubscriberViewPage';
import SentTopicListPage from './pages/SentTopicListPageProps';
import SentSubscriberListPage from './pages/SentSubscriberListPage';
import VerifySubscriberPage from "./pages/VerifySubscriberPage";

function Router()
{
    let [state, setState] = useState<number>(Math.random());

    let location = useLocation();
    let navigate = useNavigate();

    let maker = new NSARouterMaker(ProductUUID.NAMIRASOFT_NOTIFICATION_SENDER, new IStorageSession(), () => { setState(state + Math.random()); }, {
        onRenderOnLogin: (props: NSARouterMakerProps) =>
        {
            let REACT_APP_BASE_URL_NOTIFICATION_SENDER = new EnvService("REACT_APP_BASE_URL_NOTIFICATION_SENDER", true).getString();
            let REACT_APP_BASE_URL_EMAIL_SENDER = new EnvService("REACT_APP_BASE_URL_EMAIL_SENDER", true).getString();
            let REACT_APP_BASE_URL_SMS_SENDER = new EnvService("REACT_APP_BASE_URL_SMS_SENDER", true).getString();
            let REACT_APP_BASE_URL_TELEGRAM_SENDER = new EnvService("REACT_APP_BASE_URL_TELEGRAM_SENDER", true).getString();
            let servers = {
                notification_sender: new NamirasoftNotificationSenderServer(REACT_APP_BASE_URL_NOTIFICATION_SENDER, props.account.token_manager, props.notifier.onError),
                email_sender: new NamirasoftEmailSenderServer(REACT_APP_BASE_URL_EMAIL_SENDER, props.account.token_manager, props.notifier.onError),
                sms_sender: new NamirasoftSMSSenderServer(REACT_APP_BASE_URL_SMS_SENDER, props.account.token_manager, props.notifier.onError),
                telegram_sender: new NamirasoftTelegramSenderServer(REACT_APP_BASE_URL_TELEGRAM_SENDER, props.account.token_manager, props.notifier.onError),
            }
            return (
                <Routes>
                    <Route path={NotificationSenderRoutes.Home} element={<HomePage {...props} />} />
                    <Route path={NotificationSenderRoutes.TopicList} element={<TopicListPage {...props} servers={servers} />} />
                    <Route path={NotificationSenderRoutes.TopicNew} element={<TopicEditPage {...props} servers={servers} isEdit={false} />} />
                    <Route path={NotificationSenderRoutes.TopicView(":id")} element={<TopicViewPage {...props} servers={servers} />} />
                    <Route path={NotificationSenderRoutes.TopicCopy(":id")} element={<TopicEditPage {...props} servers={servers} isEdit={false} />} />
                    <Route path={NotificationSenderRoutes.TopicEdit(":id")} element={<TopicEditPage {...props} servers={servers} isEdit={true} />} />

                    <Route path={NotificationSenderRoutes.SubscriberList} element={<SubscriberListPage {...props} servers={servers} />} />
                    <Route path={NotificationSenderRoutes.SubscriberNew} element={<SubscriberEditPage {...props} servers={servers} isEdit={false} />} />
                    <Route path={NotificationSenderRoutes.SubscriberView(":id")} element={<SubscriberViewPage {...props} servers={servers} />} />
                    <Route path={NotificationSenderRoutes.SubscriberCopy(":id")} element={<SubscriberEditPage {...props} servers={servers} isEdit={false} />} />
                    <Route path={NotificationSenderRoutes.SubscriberEdit(":id")} element={<SubscriberEditPage {...props} servers={servers} isEdit={true} />} />
                    <Route path={NotificationSenderRoutes.SubscriberVerify(":subscriber_id")} element={<VerifySubscriberPage {...props} servers={servers} />} />

                    <Route path={NotificationSenderRoutes.SentTopicList} element={<SentTopicListPage {...props} servers={servers} />} />
                    <Route path={NotificationSenderRoutes.SentSubscriberList} element={<SentSubscriberListPage {...props} servers={servers} />} />

                    <Route path="*" element={<NSNotFoundPage />} />
                </Routes>
            )
        },
        onRenderOnLogout: () =>
        {
            return (
                <Routes>
                    <Route path={NotificationSenderRoutes.Home} element={<LoginPage />} />
                    <Route path="*" element={<LoginPage />} />
                </Routes>
            )
        }
    }, location, navigate);

    return maker.onRender();
}

export default Router;